'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.getElement = getElement;
exports.getScope = getScope;
exports.getSelectors = getSelectors;
var matchesSelector = void 0;
try {
  exports.matchesSelector = matchesSelector = require('matches-selector');
} catch (e) {
  exports.matchesSelector = matchesSelector = Function.prototype;
}

exports.matchesSelector = matchesSelector;


function isElement(obj) {
  // eslint-disable-line complexity
  return (typeof HTMLElement === 'undefined' ? 'undefined' : _typeof(HTMLElement)) === 'object' ? obj instanceof HTMLElement || obj instanceof DocumentFragment // eslint-disable-line
  : obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null && (obj.nodeType === 1 || obj.nodeType === 11) && typeof obj.nodeName === 'string';
}

var SCOPE_PREFIX = exports.SCOPE_PREFIX = '$$CYCLEDOM$$-';

function getElement(selectors) {
  // eslint-disable-line complexity
  var domElement = typeof selectors === 'string' ? document.querySelector(selectors) : selectors;

  if (typeof selectors === 'string' && domElement === null) {
    throw new Error('Cannot render into unknown element \'' + selectors + '\'');
  } else if (!isElement(domElement)) {
    throw new Error('Given container is not a DOM element neither a ' + 'selector string.');
  }
  return domElement;
}

function getScope(namespace) {
  return namespace.filter(function (c) {
    return c.indexOf(SCOPE_PREFIX) > -1;
  }).slice(-1) // only need the latest, most specific, isolated boundary
  .join('');
}

function getSelectors(namespace) {
  return namespace.filter(function (c) {
    return c.indexOf(SCOPE_PREFIX) === -1;
  }).join(' ');
}

var eventTypesThatDontBubble = exports.eventTypesThatDontBubble = ['load', 'unload', 'focus', 'blur', 'mouseenter', 'mouseleave', 'submit', 'change', 'reset', 'timeupdate', 'playing', 'waiting', 'seeking', 'seeked', 'ended', 'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough', 'durationchange', 'play', 'pause', 'ratechange', 'volumechange', 'suspend', 'emptied', 'stalled', 'scroll'];


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/util.js
 **/